module.exports = __webpack_public_path__ + "img/info-yellow.63b38041.svg";